import { EntityType } from "@mapmycustomers/shared";
import { EntityTypesSupportingFilteringBy } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

const entityTypesForPrefixes: EntityTypesSupportingFilteringBy[] = [
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
];

export const fieldNameEntityTypePrefixRegEx = new RegExp(
  `^(?<entityType>${entityTypesForPrefixes.join("|")})\\.`
);

export const getFieldEntityType = (
  fieldName: IField["filterName"]
): EntityTypesSupportingFilteringBy => {
  return fieldNameEntityTypePrefixRegEx.exec(fieldName)?.groups
    ?.entityType as EntityTypesSupportingFilteringBy;
};
